import AccessManagement from "./access-management";
import UserManagement from "./user-management";

const modules = [AccessManagement, UserManagement];

export default modules;
